export const sanitizeGridData = (data: any) =>
  data.map((value: any, index: number) => {
    if (value._uri && !value['Glide ID']) {
      value['Glide ID'] = value._uri;
    } else if (value['Glide ID']) {
      value['Glide ID'] = value['Glide ID'].toString();
    }
    return { ...value, ...{ id: index } };
  });
